import { render, staticRenderFns } from "./ServicesCarousel.vue?vue&type=template&id=296574dc&scoped=true&"
import script from "./ServicesCarousel.vue?vue&type=script&lang=js&"
export * from "./ServicesCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296574dc",
  null
  
)

export default component.exports